import React, { FC} from "react";
import { PaymentMethodType } from "@modules/PaymentProcessing/types";
import { AmericanExpressCardIcon } from "./Icons/AmericanExpress/AmericanExpress";
import { MastercardCardIcon } from "./Icons/Mastercard/Mastercard";
import { VisaCardIcon } from "./Icons/Visa/Visa";
import { HStack } from "@UI/Components/Stack/Stack";
import { BancontactCardIcon } from "./Icons/Bancontact/Bancontact";

interface Props {
  paymentMethod: PaymentMethodType;
}

export const PaymentMethodIcons: FC<Props> = ({ paymentMethod }) => {
  if (paymentMethod === PaymentMethodType.CREDIT_CARD) {
    return (
      <HStack spacing="5px">
        <MastercardCardIcon />
        <AmericanExpressCardIcon />
        <VisaCardIcon />
      </HStack>
    );
  } else if (paymentMethod === PaymentMethodType.BANCONTACT) {
    return <BancontactCardIcon />;
  } else {
    return <></>;
  }
};
